<section class="container-fluid sts-section">

  <app-sts-section-header *ngIf="mobileIsValid" key="sts-signup-header" [errors]="errors">
    Provide key identifiers
    <app-sts-section-header-side>
      <div class="text-right"><a routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>
  <app-sts-section-body *ngIf="mobileIsValid" key="sts-registration-body-section">
    Please provide the following information to continue the self-registration process.
    Select <b>Next</b> when you are finished.
  </app-sts-section-body>
  <form #form="ngForm" *ngIf="mobileIsValid" (ngSubmit)="onSubmit()" [formGroup]="signUpForm" class="sts-form"
    autocomplete="off">
    <div class="row sts-form-row">
      <div class="col-24">

        <div class="sts-object">

          <div class="sts-label-row">
            <label app-sts-cms-txt key="sts-pick-login-mobile" for="sts-pick-login-mobile">
              Enter your mobile phone number.
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text" name="sts_pick_mobile" formControlName="mobileInput" maxlength="100" [ngClass]="{
              'has-errors':
                !signUpForm.controls['mobileInput'].valid}" class="sts-textbox">
            <div class="text-danger"
              *ngIf="signUpForm.controls['mobileInput'].invalid && (signUpForm.controls['mobileInput'].touched || signUpForm.controls['mobileInput'].dirty)">
              <div app-sts-cms-txt key="sts-mobile-is-unique-required"
                *ngIf="signUpForm.controls['mobileInput'].errors['mobileRequired']">Your mobile phone number is required
                to continue.</div>
              <div app-sts-cms-txt key="sts-mobile-is-valid-required"
                *ngIf="signUpForm.controls['mobileInput'].errors['validateMobile']">A valid mobile number is required
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button" class="sts-btn other-sts-btn" type="button"
            (click)="gotoHome()">
            Cancel
          </button>

          <app-sts-button [submit]="submitter" key="sts-next-button">
            Next
          </app-sts-button>
        </div>

      </div>
    </div>

  </form>
</section>